<template>
  <div class="thanks" :class="{active: showPopup === true}">
    <div class="thanks-area"></div>
    <div class="thanks-modal">
      <Logo class="thanks-logo"/>
      <span class="thanks-title">Спасибо</span>
      <span class="thanks-text">за ваш вклад в борьбу с<br>кроновирусом! Ваши данные<br>были учтены!</span>
      <span class="thanks-socials__title">Поделись с родными и друзьями</span>
      <social-sharing
        media="http://alex2504.beget.tech/share.png"
        url="https://epidemic.hculture.ru/"
        title="Актуальная статистика по эпидемиологической обстановке"
        description="Обновляй информацию о состоянии своего здоровья и получай достоверную статистику по эпидемиологической обстановке в своем регионе"
        hashtags="важнознать, covid19, epidemic, covid, эпидемия, эпидемиягриппа, грипп"
        twitter-user="hculture"
        inline-template>
        <div class="thanks-socials">
          <network network="whatsapp"><img src="@/assets/socials/whatsapp.png" alt="whatsapp"></network>
          <network network="telegram"><img src="@/assets/socials/telegram.png" alt="telegram"></network>
          <network network="skype"><img src="@/assets/socials/skype.png" alt="skype"></network>
          <network network="email"><img src="@/assets/socials/email.png" alt="email"></network>
          <network network="sms"><img src="@/assets/socials/sms.png" alt="sms"></network>
          <network network="vk"><img src="@/assets/socials/vk.png" alt="vk"></network>
          <network network="odnoklassniki"><img src="@/assets/socials/ok.png" alt="ok"></network>
          <network network="facebook"><img src="@/assets/socials/facebook.png" alt="facebook"></network>
          <network network="twitter"><img src="@/assets/socials/twitter.png" alt="twitter"></network>
        </div>
      </social-sharing>
      <Button text="Закрыть" @action="closePopup"/>
    </div>
  </div>
</template>

<script>
import SocialSharing from 'vue-social-sharing';
import Button from '@/components/Button.vue';
import Logo from '@/assets/svg/logo-popup.svg';

export default {
  components: {
    Button,
    Logo,
    SocialSharing
  },
  computed: {
    showPopup() {
      return this.$store.state.thanksPopup;
    }
  },
  methods: {
    closePopup() {
      this.$store.commit('setThanksPopup', false)
    }
  }
}
</script>

<style lang="scss">
.thanks {
  left: 0;
  width: 100%;
  top: 0;
  height: 100%;
  position: fixed;
  z-index: 5;
  background:rgba(0, 0, 0, .5);
  display: none;
  &.active {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &-title {
    font-size: 40px;
    display: block;
    margin-bottom: 18px;
    text-align: center;
    font-weight: bold;
    text-transform: uppercase;
  }
  &-text {
    text-align: center;
    display: block;
    font-size: 20px;
    margin-bottom: 35px;
  }
  &-modal {
    width: 394px;
    border-radius: 10px;
    background-color: #ffffff;
    padding: 30px;
    text-align: center;
  }
  &-logo {
    margin-bottom: 70px;
  }
  &-socials {
    &__title {
      display: block;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 26px;
    }
    & img {
      width: 50px;
      cursor: pointer;
      margin: 5px 5px;
    }
  }
}

@media screen and (max-width: 767px) {
  .thanks {
    &-modal {
      width: 100%;
      padding: 10px;
      height: 100%;
      border-radius: 0;
    }
    &-logo {
      margin-bottom: 10px;
    }
    &-text {
      margin-bottom: 10px;
    }
    &-title {
      margin-bottom: 10px;
    }
    &-socials {
      margin-bottom: -20px;
      &__title {
        margin-bottom: 10px;
      }
    }
  }
}
</style>